/**
 * **사업자등록번호를 사람에게 보이는 한 곳** — 의존성 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지 — 단위 시험이 node 에서 그대로 읽는다).
 *
 * 저장은 **숫자만**이다(2026-10-30 사용자 결정 — 서버 `BizNoRules.storageForm` 이 숫자 10자리가 되는 값을 숫자만으로 저장하고, 기존 값은
 * 정리 SQL 이 맞췄다). 사람에게는 보일 때와 칠 때 모두 `000-00-00000` 으로 끊어 보인다. 입력 칸이 서버로 보내는 값은 숫자만이고,
 * 사람이 직접 친 `-`·공백·글자는 버린다.
 *
 * 끊는 자리(3·2·5)는 `ownerSignup.formatBizNoTyping`(pos2-lite 정본의 사본 — 콜팝 가맹점 웹 가입 칸) 하나가 정한다. 여기서는 다시 적지
 * 않고 그 함수를 부른다.
 *
 * 숫자 10자리가 아닌 옛 값(9·11·12자리, `-` 하나뿐 등)은 그럴듯하게 끊지 않고 받은 그대로 둔다([telNumber] 의 다 친 전화번호와 같은
 * 원칙) — 그 칸을 고치지 않으면 저장 값도 그대로다(사용자 결정 「이상한 값은 그대로 둬」).
 */
import { formatBizNoTyping } from './ownerSignup.js'

const SEPARATORS = /[-\s]/g

/** 목록·화면에 보일 사업자등록번호 — 숫자가 10자리면 `000-00-00000`, 아니면 받은 글자 그대로(빈 값은 빈 글자) */
export function bizNoDisplay(raw) {
  if (raw === null || raw === undefined) return ''
  const text = String(raw)
  const digits = text.replace(SEPARATORS, '')
  return /^[0-9]{10}$/.test(digits) ? formatBizNoTyping(digits) : text
}

/**
 * 입력 칸에 보일 모양 — 숫자만인 값(10자리까지)은 치는 대로 끊어 보인다(`123` → `123`, `12345` → `123-45`, `1234567890` →
 * `123-45-67890`). 저장된 옛 값처럼 숫자만이 아니거나 10자리를 넘으면 받은 그대로 보인다.
 */
export function bizNoFieldText(value) {
  const text = value === null || value === undefined ? '' : String(value)
  return /^[0-9]{0,10}$/.test(text) ? formatBizNoTyping(text) : text
}

/** 입력 칸에서 친 글자 → 보낼 값: 숫자만(칸에 보이던 `-`, 사람이 친 `-`·공백·글자는 버린다). 자르지 않는다 */
export function bizNoInputValue(typed) {
  return String(typed === null || typed === undefined ? '' : typed).replace(/[^0-9]/g, '')
}
